import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { ApiClient } from '../../../../api-client';
import { UnitResult } from '../../../../error';
import { Job } from '../../../Domain/Model/CreateJob/create-job.model';
import { JobId } from '../../../Domain/Model/Job/VO/job-id';
import { CreateJobService } from '../../../Domain/Port/CreateJob/create-job.service';
import { CreateJobRequest } from './Model/create-job-request';
import { CreateJobResponse } from './Model/create-job-response';

@Injectable({
    providedIn: 'root'
})
export class BackendCreateJobService extends CreateJobService {
    private readonly endpoint = '/job';

    constructor(private apiClient: ApiClient) {
        super();
    }

    override createJob(model: Job): Observable<UnitResult<JobId>> {
        const request = CreateJobRequest.fromModel(model);
        return this.apiClient.post<CreateJobRequest, CreateJobResponse>(this.endpoint, request, true).pipe(
            map(result => {
                if (result.isSuccess()) {
                    return UnitResult.success(new JobId(1));
                } else {
                    return UnitResult.failure<JobId>(result.getErrors());
                }
            })
        );
    }
}
